import React, { useRef, useState, useEffect } from 'react';

const LocalVideoPlayer = ({ 
  src, 
  title, 
  width = "720", 
  height = "405", 
  autoplay = false,
  controls = true,
  className = ""
}) => {
  const videoRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleLoadStart = () => {
      setIsLoading(true);
      setError(null);
    };

    const handleCanPlay = () => {
      setIsLoading(false);
    };

    const handleError = (e) => {
      console.error('Video error:', e);
      setError('Ошибка загрузки видео');
      setIsLoading(false);
    };

    const handleLoad = () => {
      setIsLoading(false);
    };

    video.addEventListener('loadstart', handleLoadStart);
    video.addEventListener('canplay', handleCanPlay);
    video.addEventListener('error', handleError);
    video.addEventListener('loadeddata', handleLoad);

    return () => {
      video.removeEventListener('loadstart', handleLoadStart);
      video.removeEventListener('canplay', handleCanPlay);
      video.removeEventListener('error', handleError);
      video.removeEventListener('loadeddata', handleLoad);
    };
  }, [src]);

  return (
    <div className={`video-player-container ${className}`} style={{ position: 'relative', width, height }}>
      {isLoading && (
        <div 
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#000',
            color: '#fff',
            zIndex: 1
          }}
        >
          Загрузка видео...
        </div>
      )}
      
      {error && (
        <div 
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#000',
            color: '#ffaa00',
            zIndex: 1
          }}
        >
          {error}
        </div>
      )}

      <video
        ref={videoRef}
        width={width}
        height={height}
        controls={controls}
        autoPlay={autoplay}
        preload="metadata"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          backgroundColor: '#000'
        }}
        title={title}
      >
        <source src={src} type="video/mp4" />
        Ваш браузер не поддерживает воспроизведение видео.
      </video>
    </div>
  );
};

export default LocalVideoPlayer;
